export default __webpack_public_path__ + "static/media/apenasUm.3561eceb.svg";